import script from "./AudioMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioMessage.vue?vue&type=script&setup=true&lang=ts"

import "./AudioMessage.vue?vue&type=style&index=0&id=415d49dc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415d49dc"]])

export default __exports__